export default __webpack_public_path__ + "static/media/click_sound.9c2ff485.mp3";